module.exports = __webpack_public_path__ + "img/search-normal.0abd39db.svg";